import { categories } from '@/mocks/categories';
import { Link } from 'react-router-dom';

const footerResources = [
  { name: 'SEO Guide', href: '/cssbuy-spreadsheet-guide' },
  { name: 'CSSBuy Spreadsheet 2026', href: '/cssbuy-spreadsheet-guide' },
  { name: 'Best Spreadsheet Guide', href: '/cssbuy-spreadsheet-guide' },
  { name: 'Free CSSBuy Finds', href: 'https://kaspreadsheet.com', external: true },
  { name: 'Safety Tips', href: '/cssbuy-spreadsheet-guide' },
];

const footerLegal = [
  { name: 'Privacy Policy', href: '#' },
  { name: 'Terms of Service', href: '#' },
  { name: 'Disclaimer', href: '#' },
  { name: 'DMCA', href: '#' },
  { name: 'Contact', href: '#' },
];

export default function Footer() {
  return (
    <footer className="bg-background-100">
      <div className="w-full px-6 md:px-10 py-16">
        <div className="bg-background-50 rounded-3xl px-8 md:px-12 py-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <a href="/" className="inline-block mb-4 cursor-pointer">
                <span className="font-heading text-xl font-bold text-foreground-950">
                  cssspreadsheet<span className="text-accent-500">.</span>beauty
                </span>
              </a>
              <p className="text-sm text-foreground-600 leading-relaxed max-w-xs">
                Your ultimate resource for the best CSSBuy spreadsheet in 2026. We provide free, updated spreadsheet links, comprehensive buying guides, and trusted finds across all product categories. Built for the agent shopping community.
              </p>
            </div>

            <div>
              <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-500 mb-5">
                <a href="#categories">Categories</a>
              </h4>
              <ul className="space-y-2.5">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-accent-600 transition-colors duration-150 cursor-pointer"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-500 mb-5">
                Resources
              </h4>
              <ul className="space-y-2.5">
                {footerResources.map((item) => (
                  <li key={item.name}>
                    {item.external ? (
                      <a
                        href={item.href}
                        target="_blank"
                        rel="noopener nofollow"
                        className="text-sm text-foreground-600 hover:text-accent-600 transition-colors duration-150 cursor-pointer"
                      >
                        {item.name}
                      </a>
                    ) : (
                      <Link
                        to={item.href}
                        className="text-sm text-foreground-600 hover:text-accent-600 transition-colors duration-150 cursor-pointer"
                      >
                        {item.name}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-500 mb-5">
                Legal
              </h4>
              <ul className="space-y-2.5">
                {footerLegal.map((item) => (
                  <li key={item.name}>
                    <a
                      href={item.href}
                      className="text-sm text-foreground-600 hover:text-accent-600 transition-colors duration-150 cursor-pointer"
                    >
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <span>&copy; 2026 CSSSpreadsheet.beauty. All rights reserved.</span>
            <span className="hidden sm:inline">|</span>
            <a href="#" className="hover:text-foreground-700 transition-colors cursor-pointer">Privacy</a>
            <span className="hidden sm:inline">|</span>
            <a href="#" className="hover:text-foreground-700 transition-colors cursor-pointer">Terms</a>
            <span className="hidden sm:inline">|</span>
            <a href="#" className="hover:text-foreground-700 transition-colors cursor-pointer">DMCA</a>
          </div>
          <div className="flex items-center gap-3">
            <a href="#" aria-label="Twitter" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-100 hover:bg-foreground-200 transition-colors cursor-pointer">
              <i className="ri-twitter-x-line text-foreground-600 text-sm"></i>
            </a>
            <a href="#" aria-label="Reddit" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-100 hover:bg-foreground-200 transition-colors cursor-pointer">
              <i className="ri-reddit-line text-foreground-600 text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}